import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'

// API PascalCase doner (Startup.cs: PropertyNamingPolicy = null).
// Kalan sureler mutlak zaman damgasi degil SANIYE olarak gelir: istemci saati
// sunucudan sapmissa mutlak damga yanlis sayac gosterirdi.
export interface ICardPhoneSendLinkResponse {
  VerificationId: number
  MaskedPhone: string
  ResendInSeconds: number
  ExpireInSeconds: number
}

export interface ICardPhoneStatusResponse {
  Status: number
  ExpireInSeconds: number
  CodeExpireInSeconds: number
  ResendInSeconds: number
}

// Backend CardPhoneVerificationStatus ile birebir aynı; enum değişirse burası da değişir.
export const CardPhoneStatus = {
  LinkSent: 0,
  Consented: 1,
  CodeVerified: 2,
  Used: 3,
  Expired: 4,
  Cancelled: 5,
}

export class CardPhoneApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: '',
      requesterInfo,
    })
  }

  public async sendLink(paymentControlId: number, phone: string): Promise<ICardPhoneSendLinkResponse> {
    this.props.url = 'payment/cardPhone/sendLink'
    return await this.postAsync<ICardPhoneSendLinkResponse>({ PaymentControlId: paymentControlId, Phone: phone })
  }

  public async resendLink(verificationId: number): Promise<ICardPhoneSendLinkResponse> {
    this.props.url = 'payment/cardPhone/resendLink'
    return await this.postAsync<ICardPhoneSendLinkResponse>({ VerificationId: verificationId })
  }

  public async getStatus(verificationId: number): Promise<ICardPhoneStatusResponse> {
    this.props.url = 'payment/cardPhone/status'
    return await this.postAsync<ICardPhoneStatusResponse>({ VerificationId: verificationId })
  }

  public async verifyCode(verificationId: number, code: string): Promise<boolean> {
    this.props.url = 'payment/cardPhone/verifyCode'
    return await this.postAsync<boolean>({ VerificationId: verificationId, Code: code })
  }
}
